export const THREAD_ENTITY_TYPE = 'MMP_ORDER'
export const SUBJECT_TYPE_INCIDENT_CLOSE = 'INCIDENT_CLOSE'
export const SUBJECT_TYPE_INCIDENT_OPEN = 'INCIDENT_OPEN'
export const SUBJECT_TYPE_OFFER_MESSAGING = 'OFFER_MESSAGING'
export const SUBJECT_TYPE_ORDER_MESSAGING = 'ORDER_MESSAGING'
export const SUBJECT_TYPE_CANCELATION = 'CANCELATION'
export const PARTICIPANT_TYPE_OPERATOR = 'OPERATOR'
export const PARTICIPANT_TYPE_CUSTOMER = 'CUSTOMER'
export const PARTICIPANT_TYPE_SHOP = 'SHOP'
export const PARTICIPANT_TYPE_ID = '2058' // This should be removed and we should not hardcoded the SHOP ID

export const VISIBLE_THREADS_COUNT = 5

export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png'
]

export const MAX_MESSAGE_LENGTH = 50000
export const MIN_MESSAGE_LENGTH = 3
export const MAX_FILE_SIZE_MB = 10
